import styled from 'styled-components';
import { theme } from '../../styles/theme';

interface CardProps {
  elevation?: 'small' | 'medium' | 'large';
  padding?: boolean;
}

const Card = styled.div<CardProps>`
  background-color: ${theme.colors.background};
  border-radius: ${theme.radii.medium};
  box-shadow: ${({ elevation }) => 
    elevation === 'small' ? theme.shadows.small :
    elevation === 'large' ? theme.shadows.large :
    theme.shadows.medium
  };
  padding: ${({ padding }) => padding ? theme.spacing.md : '0'};
  overflow: hidden;
  width: 100%;
`;

Card.defaultProps = {
  elevation: 'medium',
  padding: true,
};

export default Card; 